"use strict";

export default angular.module("contartemx.administracion.colaboradores", [
    "contartemx",
    "ui.bootstrap",
    "tableTools",
    "loader"
])
    .controller("AdministracionColaboradoresCtrl", ($scope, $rootScope, $state, $cookies, $filter, apiCall, mostrarNotificacion, localStorageService, $timeout, NgTableParams) => {

        const paramsIniciales = { count: 10 };

        $scope.loading = true;

        apiCall.post("ObtenerUsuariosColaboradores")
            .then(r => {
                if (angular.isArray(r.Respuesta)) {
                    
                    $scope.usuarios = $filter('filter')(r.Respuesta, { EstaActivo: true });
  
                    $scope.tableParams = new NgTableParams(paramsIniciales,
                        {
                            dataset: $scope.usuarios,
                            counts: [],
                        });             
                }
            })
            .finally(() => $scope.loading = false);

    });
